import { render, staticRenderFns } from "./ordersListTable.vue?vue&type=template&id=11821d36&scoped=true"
import script from "./ordersListTable.vue?vue&type=script&lang=js"
export * from "./ordersListTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListTable.vue?vue&type=style&index=0&id=11821d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11821d36",
  null
  
)

export default component.exports